import chroma from "chroma-js";
import forEach from "lodash/forEach";
import join from "lodash/join";
import reverse from "lodash/reverse";
import split from "lodash/split";
const COLOR_FOR_AVERAGE_GRAY = "#ccc";
const COLOR_FOR_AVERAGE_WHITE = "#fff";
const calculateCorrectedColor = (color, luminance) => {
    const contrast = chroma.contrast(color, COLOR_FOR_AVERAGE_GRAY);
    let resultColor = color;
    if (contrast > 7) {
        resultColor = chroma
            .average([color, COLOR_FOR_AVERAGE_WHITE], "rgb", [
            parseFloat((contrast * (contrast > 9 ? 0.3 : 0.5)).toFixed(1)),
            1
        ])
            .css();
    }
    else if (contrast <= 4.5) {
        resultColor = chroma
            .average([color, COLOR_FOR_AVERAGE_GRAY], "rgb", [parseFloat(contrast.toFixed(1)), 1])
            .css();
    }
    if (luminance) {
        resultColor = chroma(resultColor).luminance(luminance).css();
    }
    return resultColor;
};
export default (text, luminance) => {
    if (!text)
        return "#FFFFFF";
    let hash = 0;
    forEach(text, (_, i) => {
        hash = text.charCodeAt(i) + ((hash << 5) - hash);
        hash &= hash;
    });
    let color = "";
    for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 255;
        color += `00${value.toString(16)}`.substr(-2);
    }
    return calculateCorrectedColor(`#${join(reverse(split(color, "")), "")}`, luminance);
};
